module.exports = __webpack_public_path__ + "static/img/3-CN.5be7f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m/3-CN.png
// module id = b3ry
// module chunks = 1